import React, { useEffect, useState } from 'react';
import Security from '../../commons/security/Security';
import { Redirect } from 'react-router-dom';
import ConfigBusiness from '../../commons/config/ConfigBusiness';
import '../../assets/css/bi-iframe.css';
import { PERMISSION_PATH } from '../../commons/constants/biSuitePermissionPath';

const BISuite = (props) => {
    
    const [redirecTo, setRedirecTo] = useState(null);
    const [iframeUrl, setIframeUrl] = useState('');
    const [isValidUrl, setIsValidUrl] = useState(false)

    useEffect(() => {
        const checkPermissionsAndUrl = async () => {
            const { pathname } = props.location;
            const havePermission = PERMISSION_PATH.find(permission => permission.path === pathname);
            const habilitado = ConfigBusiness.get(`menu.BISuite.submenu${havePermission.urlKey}.habilitado`);
    
            if(!havePermission || !Security.hasPermission(havePermission.permission) || habilitado === 'false') {
                setRedirecTo('/error');
                return;
            }
    
            const url = ConfigBusiness.get(`menu.BISuite.submenu${havePermission.urlKey}.url`);
            const isValid = await checkUrl(url);

            if (isValid) {
                setIframeUrl(url);
                setIsValidUrl(true);
            } else {
                setRedirecTo('/biUrlError');
            }
        }

        checkPermissionsAndUrl();

    }, [props.location]);

    async function checkUrl(url) {
        try {
            new URL(url);
            return true;
        } catch (e) {
            return false;
        }
    }

    return (
        <div className="iframe-container">
            {redirecTo && <Redirect push to={redirecTo} />}
            {isValidUrl && <iframe
                title="BI SUITE VEC - AR"
                src={iframeUrl}
                allowFullScreen={true}
                className="responsive-iframe">
            </iframe>}
        </div>
    )
}

export default BISuite;